import { Property } from "../../models/property.model";
import { PropertiesActionTypes } from "../actions/types";
import { Dispatch } from "redux";

export interface PropertiesAction {
  type: PropertiesActionTypes;
  payload: Property;
}

export const propertiesActions = {
  addProperty: (property: Property) => {
    return (dispatch: Dispatch) => {
      dispatch<PropertiesAction>({
        type: PropertiesActionTypes.ADD_PROPERTY,
        payload: property
      });
    };
  }
};
